<template>
  <div :class="$style[classes]">
      <div v-for="(item,index) in statusArray" :key="index" :class="$style['status-div-item']">
        <span :style="{background:item.color}" :class="$style.ball"></span>{{item.text}}
    </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-legend'

export default {
  name: 'pt-legend',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    statusArray: {
      type: Array,
      default: () => {
        return []
      }
    },
    text: {
      type: String
    },
    // 颜色，支持：#fafafa,white
    color: {
      type: String
    },
    type: {
      type: String, // 'normal'正常,'abnormal'异常,'pending'待处理
      default: ''
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-legend{
  color:#969696;
  margin-right: 50px;
  display: flex;
  &:last-child{
    margin-right: 0px;
  }
  .ball{
    width:14px;
    height: 14px;
    display: inline-block;
    margin-right: 10px;
    border-radius: 50%;
  }
}
.status-div-item{
    display: flex;
    align-items: center;
    &+.status-div-item{
        padding-left: 35px;
    }
}
</style>
